import { render, staticRenderFns } from "./DropdownAction.vue?vue&type=template&id=3518c944&scoped=true&"
import script from "./DropdownAction.vue?vue&type=script&lang=js&"
export * from "./DropdownAction.vue?vue&type=script&lang=js&"
import style0 from "./DropdownAction.vue?vue&type=style&index=0&id=3518c944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3518c944",
  null
  
)

export default component.exports